import React, { useId, useRef, useState } from 'react';
// @ts-ignore Lib has no type declarations
import { CardVideo, ShefIcon, StarIcon, TimeIcon, SeeMoreCardArrow } from '../Icons/icons';
import { Title, Text } from '../Typography';
import { getColor, rgbToHsl } from '../../modules/colorUtils';
import { ICard } from './ICard';
import { LiquidButton } from '../LiquidButton';
import GetSafari from '../../modules/getSafari';

import {
  ArrowWrapper,
  Wrapper,
  LinkWrapper,
  Container,
  Content,
  Dots,
  HiddenImageForColorDetection,
  HiddenUntilHoverOrFocus,
  Info,
  MainContainer,
  ObjectImage,
  Svg,
  Video,
  VideoCircle,
  ProductsAmount,
  ButtonContainer,
  Image,
  ProductImage,
  ProductTitle,
  ProductSubTitle,
  SubCategoryImage,
} from './styles';

const idPrefix = 'gooey-react';

export const Card = ({
  data,
  cardVariation = 'recipe',
  showInfo = false,
  link,
  height = '100%',
  textAlign = 'text-center',
  cardType,
  video = false,
  copyDictionary,
  LinkComponent,
  saturation = 35,
  lightness = 75,
  customColor,
  isAuthorableGrid = false,
  showAll = false,
}: ICard) => {
  const idString = useId();
  const id = idPrefix + idString;
  const isSafari = GetSafari();
  // On basis of Cardtype styling

  if (data?.metaData?.images?.[0]?.url && cardVariation === 'article')
    cardVariation = 'articleImage';
  let videoposition: string | '-mt-12';
  switch (cardType) {
    case 'big':
      videoposition = '-mt-20';
      break;
    case 'small':
      videoposition = '-mt-12';
      break;
    case 'mediumSmall':
      videoposition = '-mt-12';
      break;
    case 'tiny':
      videoposition = '-mt-12';
      break;
    case 'medium':
      videoposition = '-mt-12';
      break;
    default:
      videoposition = '-mt-12';
      break;
  }

  let objectImage = 'w-8/12';
  if (
    (cardType === 'small' && cardVariation === 'product') ||
    (cardType === 'small' && cardVariation === 'object') ||
    cardType === 'tiny'
  ) {
    objectImage = `w-8/12`;
  }
  if (cardType != 'small' && cardVariation === 'product') {
    objectImage = `w-8/12`;
  }
  if (data?.button) {
    objectImage = `w-6/12`;
  }
  if (cardType === 'mediumSmall' && cardVariation === 'product') {
    objectImage = `w-auto max-h-productCardHeight`;
  }
  // md:h-productCardHeight
  const breadcrumb = `text-darkgray tracking-widest text-opacity-75 text-sm mt-3.5 pb-2.5 leading-4 font-geomanist uppercase ${textAlign}`;

  const containerRef = useRef<HTMLDivElement>(null);
  const imageRef = useRef<HTMLImageElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const subNavRef = useRef<HTMLDivElement>(null);
  const [dominantColor, setDominantColor] = useState<number>(0);
  let cardColor = '';
  let bigCardDimension = 1000;
  // TODO dummyImage need to provide in for fallback condition.
  const fallbackImage: Record<string, any> = {
    product: {
      url: 'https://media.graphcms.com/resize=fit:clip,height:400/output=format:webp/9EoUOPS2RuemvH8SZfhv',
      fallback:
        'https://media.graphcms.com/resize=fit:clip,height:400/output=format:png/9EoUOPS2RuemvH8SZfhv',
    },
    recipe: {
      url: 'https://media.graphcms.com/resize=fit:clip,height:300/output=format:webp/KRKDwK2fTsqCY6HE7EsD',
      fallback:
        'https://media.graphcms.com/resize=fit:clip,height:300/output=format:png/KRKDwK2fTsqCY6HE7EsD',
    },
    tipsAndTricks: {
      url: 'https://media.graphcms.com/resize=fit:clip,height:400/output=format:webp/1Lh0LaYcTjqXhyiXMsGl',
      fallback:
        'https://media.graphcms.com/resize=fit:clip,height:400/output=format:png/1Lh0LaYcTjqXhyiXMsGl',
    },
  };

  let fallbackFinalImage = fallbackImage[cardVariation || 'recipe'] || fallbackImage.recipe;
  if (cardVariation === 'articleImage') {
    fallbackFinalImage = data?.metaData?.images?.[0]?.url || '';
  }

  let desktopImage = '';
  let mobileImage = '';
  let tabletImage = '';
  let cardImage = '';

  if (data?.images) {
    if (isSafari) {
      desktopImage =
        data?.images?.desktopFallback || data?.images?.heroFallback || fallbackFinalImage.fallback;
      mobileImage =
        data?.images?.mobileFallback ||
        data?.images?.heroFallback ||
        data?.images?.desktopFallback ||
        fallbackFinalImage.fallback;
      tabletImage =
        data?.images?.tabletFallback ||
        data?.images?.heroFallback ||
        data?.images?.desktopFallback ||
        fallbackFinalImage.fallback;
      cardImage =
        data?.images?.mobileFallback ||
        data?.images?.tabletFallback ||
        data?.images?.desktopFallback ||
        data?.images?.heroFallback ||
        fallbackFinalImage.fallback;
    } else {
      desktopImage =
        data?.images?.desktop ||
        data?.images?.hero ||
        data?.images?.heroFallback ||
        fallbackFinalImage.url;
      mobileImage =
        data?.images?.mobile ||
        data?.images?.hero ||
        data?.images?.desktop ||
        data?.images?.heroFallback ||
        fallbackFinalImage.url;
      tabletImage =
        data?.images?.tablet ||
        data?.images?.hero ||
        data?.images?.desktop ||
        data?.images?.heroFallback ||
        fallbackFinalImage.url;
      cardImage =
        data?.images?.mobile ||
        data?.images?.tablet ||
        data?.images?.desktop ||
        data?.images?.hero ||
        data?.images?.heroFallback ||
        fallbackFinalImage.url;
    }
  } else {
    // TODO: remove it once add all webp images
    desktopImage =
      data?.image?.desktop || data?.image?.hero || data?.image || fallbackFinalImage.url;
    mobileImage =
      data?.image?.mobile ||
      data?.image?.hero ||
      data?.image?.desktop ||
      data?.image ||
      fallbackFinalImage.url;
    tabletImage =
      data?.image?.tablet ||
      data?.image?.hero ||
      data?.image?.desktop ||
      data?.image ||
      fallbackFinalImage.url;
    cardImage =
      data?.image?.mobile ||
      data?.image?.tablet ||
      data?.image?.desktop ||
      data?.image?.hero ||
      data?.image ||
      fallbackFinalImage.url;
  }

  const computeImageColor = () => {
    if (imageRef && imageRef.current && !customColor) {
      getColor(imageRef.current).then((color) => {
        const getHslColor = rgbToHsl(color.value);
        setDominantColor(getHslColor[0]);
      });
    }
  };
  cardColor = customColor || `hsl(${dominantColor}, ${saturation}%, ${lightness}%)`;

  const CardBackgroundImage = () => {
    if (typeof window !== 'undefined') {
      const innerWidth = window.innerWidth;
      if (innerWidth >= 1024 && desktopImage) {
        return desktopImage;
      }
      if (innerWidth >= 700 && tabletImage) {
        return tabletImage;
      }
      if (innerWidth > 320 && innerWidth < 700) {
        return mobileImage;
      }
    }
    return cardImage;
  };
  // templates
  const getImageTmpl = (type: string | undefined) => {
    if (
      ['recipe', 'tipsAndTricks', 'white', 'WideSmall', 'content', 'articleImage'].includes(
        type || '',
      )
    ) {
      return (
        <Image>
          <HiddenImageForColorDetection
            ref={imageRef}
            data-src={CardBackgroundImage()}
            crossOrigin=""
            alt=""
            onLoad={computeImageColor}
            className="lazyload"
            width="100%"
            height="100%"
          />
        </Image>
      );
    }
    return '';
  };
  const getVideoTmpl = (
    <Video className={videoposition} $backgroundHsl={cardColor}>
      <VideoCircle>
        <CardVideo />
      </VideoCircle>
    </Video>
  );
  const getInfoTmpl = showInfo && data?.information && (
    <Info data-test="card-info">
      {!!data.information?.rating && (
        <span>
          <StarIcon data-test="star-icon" className="align-baseline mx-px my-0 inline" />
          <Text data-test="rating-info" tag="span" type="sm" className="inline-block ml-1">
            {data.information.rating}
          </Text>
        </span>
      )}
      {!!data.information?.rating && !!data?.information.preparationTime && (
        <Dots data-test="dots-info-show" className="inline-block" />
      )}
      {!!data.information?.preparationTime && (
        <span>
          <TimeIcon data-test="time-icon" className="align-baseline mx-px my-0 inline" />
          <Text
            data-test="preparation-time-info"
            tag="span"
            type="sm"
            className="inline-block ml-1"
          >
            {data.information.preparationTime}
          </Text>
        </span>
      )}
      {!!copyDictionary &&
        data.information?.difficulty !== undefined &&
        !!data.information?.preparationTime && <Dots data-test="dots-between-info" />}
      {!!copyDictionary && data.information?.difficulty !== undefined && (
        <span>
          <ShefIcon data-test="shef-icon" className="align-baseline mx-px my-0 inline" />
          <Text data-test="difficulty-info" tag="span" type="sm" className="inline-block ml-1">
            {copyDictionary[data.information.difficulty]}
          </Text>
        </span>
      )}
    </Info>
  );

  const onCardClick = () => {
    window.dataLayer = window.dataLayer || [];
    const eventName = cardVariation === 'tipsAndTricks' ? 'tiptrick_recipe' : cardVariation;
    window.dataLayer.push({
      event: `click_${eventName}`,
      eventValues: {
        ec: eventName,
        ea: 'click',
        el: `${data?.title}`,
        recipe_tiptrick_name: `${data?.title}`,
      },
    });
  };

  let titleType = 'xs';

  switch (cardType) {
    case 'big':
      titleType = 'sm';
      break;
    case 'medium':
      titleType = 'xs';
      break;
    case 'mediumSmall':
      titleType = 'xxs';
      break;
    case 'small':
      titleType = 'xxxs';
      break;
    case 'tiny':
      titleType = 'xxxs';
      break;
    default:
      titleType = 'sm';
  }
  // make font size responsive to card width
  if (contentRef.current) {
    const elmRect = contentRef.current.getBoundingClientRect();
    if (elmRect.width < 370 && isAuthorableGrid) {
      titleType = 'xxxs';
    }
  }

  const arrow = (
    <ArrowWrapper>
      <SeeMoreCardArrow data-test={[`${id}-right-arrow`]} />
    </ArrowWrapper>
  );

  const categorySubCategoryText = (
    <div ref={subNavRef} className={breadcrumb} data-test="subnavlink">
      {data?.category && (
        <Text tag="p" type="sm" className="inline-block">
          {data.category}
        </Text>
      )}
      {!!(data?.category && data?.subCategory) && <span className="px-2">/</span>}
      {data?.subCategory && (
        <Text tag="p" type="sm" className="inline-block">
          {data.subCategory}
        </Text>
      )}
    </div>
  );
  const cardDataTest = `card_type: ${cardType} | card_variation: ${cardVariation}`;

  const productCard = (
    <Wrapper $height="400px" data-test="card">
      <MainContainer>
        <Container
          className="card-container"
          $variation={cardVariation}
          data-test={`card-${data?.id}`}
          ref={containerRef}
          onClick={onCardClick}
        >
          <ProductImage>
            <img
              ref={imageRef}
              data-src={cardImage}
              crossOrigin=""
              alt=""
              className="lazyload"
              width="190"
              height="250"
            />
          </ProductImage>
          <Content
            className="card-content-wrapper"
            ref={contentRef}
            $backgroundHsl={cardColor}
            $variation={cardVariation}
            data-test={cardDataTest}
          >
            <div className="relative" data-test="card-contents">
              <Svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 624 28"
                $variation={cardVariation}
                $type={cardType}
                className="svg-product"
              >
                <path
                  fill="none"
                  stroke="#BBC4BA"
                  d="M16 203C7.16344 203 0 195.837 0 187V21.351C0 21.351 143.433 -1.4836e-05 313.3 0C483.167 1.48361e-05 624 21.3511 624 21.3511V187C624 195.837 616.836 203 608 203H16Z"
                />
              </Svg>
              <ProductSubTitle
                tag="div"
                type="lead"
                className="text-darkgray text-opacity-75"
                data-test="subnavlink"
                // @ts-ignore
                ref={subNavRef}
              >
                {data?.category}
                {!!(data?.category && data?.subCategory) && <span className="px-2">/</span>}
                {data?.subCategory}
              </ProductSubTitle>
              {data?.title && (
                <ProductTitle
                  tag="h2"
                  type="xxs"
                  data-test="card-title"
                  className="text-center tracking-xs"
                >
                  {data.title}
                </ProductTitle>
              )}
              <HiddenUntilHoverOrFocus
                $showAll={showAll}
                className={showAll ? '' : 'hidden-until-hover-or-focus-on-desktop'}
              >
                {data?.button ? (
                  <ButtonContainer $showAll={showAll}>
                    <LiquidButton
                      data-test={`action-button-${data?.id}`}
                      text={data?.button}
                      layer1Velocity="0.24"
                      layer2Velocity="0.24"
                      layer1MouseForce="559"
                      layer2MouseForce="368"
                      layer1ForceLimit="13.1"
                      layer2ForceLimit="9.6"
                      forceFactor="0.7"
                      height={50}
                      width={200}
                      color1="#010E54"
                      color2="#010e54"
                      color3="#889887"
                      hoverFactor={-1}
                      textColor="#fff"
                    />
                  </ButtonContainer>
                ) : (
                  !!link?.displayName && (
                    <div className="text-center h-fit">
                      <Text
                        data-test={`action-link-${data?.id}`}
                        tag="div"
                        type="lead"
                        className={`${textAlign} pt-6 inline text-base font-medium tracking-widest`}
                      >
                        {link?.displayName}
                      </Text>
                      <span aria-hidden="true" className="ml-18">
                        {arrow}
                      </span>
                    </div>
                  )
                )}
              </HiddenUntilHoverOrFocus>
            </div>
          </Content>
        </Container>
      </MainContainer>
    </Wrapper>
  );

  // All cards excluding Product Card
  const regularCardContent = (isPlaceholder: boolean) => (
    <Content
      className="card-content-wrapper"
      ref={contentRef}
      $backgroundHsl={cardColor}
      $variation={cardVariation}
      $type={cardType}
      $isPlaceholder={isPlaceholder}
      data-test={cardDataTest}
    >
      {video && getVideoTmpl}
      {cardVariation === 'object' && (
        <ObjectImage className="card-image" $cardVariation={cardVariation}>
          <img
            className={`lazyload ${objectImage}`}
            ref={imageRef}
            data-src={cardImage}
            crossOrigin=""
            alt=""
            width="230"
            height="230"
          />
        </ObjectImage>
      )}
      <div className={`relative card-content-big`} data-test="card-contents">
        <Svg
          xmlns="http://www.w3.org/2000/svg"
          $variation={cardVariation}
          $type={cardType}
          viewBox="0 0 624 28"
        >
          <path
            fill={cardVariation === 'white' ? '#ffffff' : cardColor}
            stroke={cardVariation === 'white' ? '#BBC4BA' : 'none'}
            d="M16 203C7.16344 203 0 195.837 0 187V21.351C0 21.351 143.433 -1.4836e-05 313.3 0C483.167 1.48361e-05 624 21.3511 624 21.3511V187C624 195.837 616.836 203 608 203H16Z"
          />
        </Svg>
        <div
          className={
            cardType === 'big' || (200 > bigCardDimension && isAuthorableGrid)
              ? 'relative -top-8'
              : ''
          }
        >
          {['article', 'articleImage', 'object', 'subcategory'].includes(cardVariation || '')
            ? categorySubCategoryText
            : isPlaceholder || (
                <HiddenUntilHoverOrFocus
                  $showAll={showAll}
                  className={showAll ? '' : 'hidden-until-hover-or-focus-on-desktop'}
                >
                  {categorySubCategoryText}
                </HiddenUntilHoverOrFocus>
              )}

          {data?.productsAmount && (
            <ProductsAmount tag="p" type="sm">
              {data.productsAmount}
            </ProductsAmount>
          )}

          {getInfoTmpl}

          {data?.title && (
            <Title
              tag="h2"
              type={titleType}
              data-test="card-title"
              className="text-center tracking-xs font-medium"
            >
              {data.title}
            </Title>
          )}
          {isPlaceholder || (
            <HiddenUntilHoverOrFocus
              $showAll={showAll}
              className={showAll ? '' : 'hidden-until-hover-or-focus-on-desktop'}
            >
              {data?.button ? (
                <ButtonContainer $showAll={showAll}>
                  <LiquidButton
                    data-test={`action-button-${data?.id}`}
                    text={data?.button}
                    layer1Velocity="0.24"
                    layer2Velocity="0.24"
                    layer1MouseForce="559"
                    layer2MouseForce="368"
                    layer1ForceLimit="13.1"
                    layer2ForceLimit="9.6"
                    forceFactor="0.7"
                    height={50}
                    width={200}
                    color1="#010E54"
                    color2="#010e54"
                    color3="#889887"
                    hoverFactor={-1}
                    textColor="#fff"
                  />
                </ButtonContainer>
              ) : (
                !!link?.displayName && (
                  <div className="text-center pt-4">
                    <Text
                      data-test={`action-link-${data?.id}`}
                      tag="div"
                      type="lead"
                      className={`${textAlign} inline text-base font-medium tracking-widest`}
                    >
                      {link?.displayName}
                    </Text>
                    <span aria-hidden="true" className="ml-18">
                      {arrow}
                    </span>
                  </div>
                )
              )}
            </HiddenUntilHoverOrFocus>
          )}
        </div>
      </div>
    </Content>
  );

  const regularCard = (
    <Wrapper $height={height} data-test="card">
      <MainContainer>
        <Container
          className="card-container"
          $variation={cardVariation}
          data-test={`card-${data?.id}`}
          ref={containerRef}
          onClick={onCardClick}
        >
          {cardVariation === 'subcategory' && (
            <SubCategoryImage>
              <img
                ref={imageRef}
                data-src={cardImage}
                crossOrigin=""
                alt=""
                className="lazyload"
                width="100%"
                height="100%"
              />
            </SubCategoryImage>
          )}

          {getImageTmpl(cardVariation)}
          {regularCardContent(false)}
          {!['object', 'article'].includes(cardVariation as string) && regularCardContent(true)}
        </Container>
      </MainContainer>
    </Wrapper>
  );
  return (
    <LinkWrapper $variation={cardVariation} $dominantColor={cardColor}>
      <LinkComponent
        className="card-link-component"
        data-test={`card-link-${id}`}
        id={`card-link-${id}`}
        href={link?.url || '/'}
      >
        {LinkComponent !== 'a' ? (
          <a className="card-link-component" href={link?.url || '/'}>
            {cardVariation === 'product' ? productCard : regularCard}
          </a>
        ) : cardVariation === 'product' ? (
          productCard
        ) : (
          regularCard
        )}
      </LinkComponent>
    </LinkWrapper>
  );
};
